import React from "react";
import ico_info from "../assets/icons/ico_info.png";
const SpeciesInfo = (props) => {
  return (
    <div className=" w-full h-28 relative mb-20 2xl:px-[350px] xl:px-44 lg:px-28 md:px-28 sm:px-28 px-10 flex flex-row justify-center items-center">
      <div className=" w-full h-full 2xl:gap-10 xl:gap-10 lg:gap-10 md:gap-10 sm:gap-5 gap-3 bg-[#004a22] flex flex-row 2xl:px-10 xl:px-10 lg:px-10 md:px-10 sm:px-7 px-3 items-center">
        <img
          src={ico_info}
          className=" 2xl:h-16 xl:h-16 lg:h-16 md:h-16 sm:h-10 h-8"
        ></img>

        <p className=" text-white 2xl:text-lg xl:text-lg lg:text-lg md:text-sm sm:text-xs text-xs">
          Las especies de flora y fauna que observará son una representación de
          la biodiversidad de la región centroamericana y el caribe, le
          invitamos a investigar más pasa saber cuáles de ellas se encuentran en
          su país.
        </p>
      </div>
    </div>
  );
};

export default SpeciesInfo;
